import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Box, device } from 'vqp-common';
import { useHistory } from 'react-router-dom';

import { LoginHeader, LoginForm } from './';
import { useStore } from '../../providers/store.provider';
import { login, logout } from '../../redux/actions/auth';
import { fetchStoreInformation, fetchStoreMultistore } from '../../redux/actions/store';
import { fetchUserAccessControl } from '../../redux/actions/access-control';

const WrapperBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  @media ${device.desktop} {
    width: 520px !important;
  }

  & form {
    width: 100%;
  }
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.error};
  text-align: center;
`;

export const LoginBox = ({ multistore }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const isMountedRef = useRef(true);

  const history = useHistory();
  const storeProvider = useStore();

  useEffect(() => {
    isMountedRef.current = true;
    return () => { isMountedRef.current = false; };
  }, []);

  const handleLogin = async ({ storeId, user, pass }) => {
    try {
      setLoading(true);
      setError();

      localStorage.setItem('multistore', Boolean(multistore));
      storeProvider.setMultistoreState(Boolean(multistore));

      const loginResponse = await dispatch(login({ storeId, user, pass }));
      if (!loginResponse.success) {
        throw new Error(loginResponse.error || 'Falha no login.');
      }

      history.replace('/');

      await Promise.all([handleMultiStore(), handleStoreInformation(), handleAccessControl()]);
    } catch (err) {
      if (isMountedRef.current) setError(err.message);
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  };

  const handleMultiStore = async () => {
    if (!multistore) {
      return;
    }

    const multistoreResponse = await dispatch(fetchStoreMultistore());
    if (!multistoreResponse.success) {
      const errorMessage = 'Falha ao buscar dados de multi-lojas.';
      handleLogout(multistoreResponse.error || errorMessage);
      throw new Error(errorMessage);
    }

    storeProvider.setStores(multistoreResponse.payload.stores);
    storeProvider.setMultistoreState(true);
    localStorage.setItem('multistore', true);
  };

  const handleStoreInformation = async () => {
    const infoResponse = await dispatch(fetchStoreInformation());
    if (!infoResponse.success) {
      throw new Error(infoResponse.error || 'Falha ao buscar informações da loja.');
    }
  };

  const handleAccessControl = async () => {
    const accessControlResponse = await dispatch(fetchUserAccessControl());
    if (!accessControlResponse.success) {
      throw new Error(
        accessControlResponse.error || 'Falha ao buscar informações de acesso do usuário.'
      );
    }
  };

  const handleLogout = (errorMessage) => {
    dispatch(logout());
    history.push({ pathname: '/multilojas' });
    setError(errorMessage);
  };

  return (
    <WrapperBox width="50%">
      <LoginHeader />
      <LoginForm
        multistore={multistore}
        handleLogin={handleLogin}
        loading={loading}
      />
      <ErrorMessage>{error}</ErrorMessage>
    </WrapperBox>
  );
};
